import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { EmployeeTrainingEntity } from "../employee-training-entity";
import { CommonResponse } from "@gtpl/shared-models/production-management";
import { UnitCodes } from "../../unit-codes/unit-codes.entity";
import appSettings from "apps/services/config";
import { EmployeeByPlant } from "./employees-by-plant";

@Injectable()
@EntityRepository(EmployeeTrainingEntity)
export class EmployeeTrainingRepo extends Repository<EmployeeTrainingEntity> {

    constructor() {
        super();
    }

    async getEmpTrainingData(req?:EmployeeByPlant): Promise<any> {
        const query = this.createQueryBuilder('ed')
            .select([
                'ed.training_id AS trainingId',
                'ed.training_title AS trainingTitle',
                'ed.faculty AS faculty',
                'ed.date_of_training AS dateOfTraining',
                'ed.plant AS plant',
                'unc.unit_name AS unitName'
            ])
            .leftJoin(
                UnitCodes, 'unc',
                'unc.unit_code_id = ed.plant'
            )
            if (req.plant && req.plant > 0) {
                query.where('ed.plant = :plant', { plant: req.plant });
            }
            query.groupBy('ed.date_of_training');

    
        return await query.getRawMany();
    }
    


}